<template>
  <el-dialog
      :visible.sync="visible"
      title="开票明细修改"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="品番号：" prop="code">
            {{dataForm.product.code}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="品名：" prop="name">
            {{dataForm.product.name}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="尺寸：" prop="size">
            {{dataForm.product.size}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="颜色：" prop="color">
            {{dataForm.product.color}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="SKU编号：" prop="skuCode">
            {{dataForm.product.skuCode}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="中文品名：" prop="nameZh">
            {{dataForm.product.nameZh}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开票数量：" prop="count">
            <el-input
                v-model="dataForm.count"
                placeholder="开票数量"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开票单价：" prop="price">
            <el-input
                v-model="dataForm.price"
                placeholder="请输入开票单价"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="总金额：" >
            {{ this.totalAmount }}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button @click="visible=false">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t("confirm")
        }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
/**
 * 单独修改发票明细(仅提供修改功能)
 */
import { moneyValidator,isPositiveNumber } from "@/utils/validate";
import debounce from "lodash/debounce";
export default {
  name:'detail-edit-dialog',
  data() {
    return {
      id: "",
      visible: false,
      dataForm: {
        product:{}
      },
    };
  },
  computed: {
    totalAmount() {
      if (!this.dataForm.count || !this.dataForm.price) {
        return 0;
      }
      return new this.$BigNumber(this.dataForm.price)
          .multipliedBy(this.dataForm.count)
          .toFixed(2);
    },
    dataRule() {
      return {
        price: [
          { required: true, message: "请填写单价", trigger: "change" },
          { validator: moneyValidator, trigger: "change" },
        ],
        count: [
          { required: true, message: "请填写数量", trigger: "change" },
          {
            validator: function (rule, value, callback) {
              if(value&&!isPositiveNumber(value)){
                callback(new Error("请输入正确的数量"));
              }else{
                callback();
              }
            },
            trigger: "change",
          },
        ]
      };
    },
  },
  methods: {
    init(data) {
      this.dataForm={
        ...data
      }
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs["dataForm"].validate((valid) => {
            if (!valid) {
              return false;
            }
            let postForm={
              id:this.dataForm.id,
              count:this.dataForm.count,
              price:this.dataForm.price
            }
            this.$api2.post(`/erp/receipt/detail/edit`,postForm).then(res=>{
              this.$emit('changed')
              this.$c.success()
              this.visible=false
            })
          });
        },
        1000,
        { leading: true, trailing: false }
    ),

  },
};
</script>
